import 'slick-carousel';
import "slick-carousel/slick/slick.scss";
import "./../css/style.scss";
import $ from 'jquery';
/*global vars*/
/*eslint no-undef: "error"*/
/*global dataLayer*/
/*eslint no-undef: "error"*/

$.migrateMute = true;

// Hide Header on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(document).ready(function () {
    hasScrolled();
    if ($(".gform_wrapper").length) {
        $(document).on('focus', '.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio) input', function () {
            $(this).closest(".gfield").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio) input', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("focused");
            }
        });
        $(document).on('focus', '.gform_wrapper .ginput_container textarea', function () {
            $(this).closest(".gfield").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_container textarea', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield").removeClass("focused");
            }
        });

        $(document).on('change', '.gform_wrapper .ginput_container select', function () {
            if ($(this).val() !== '') {
                $(this).closest(".gfield").addClass("focused");
            } else {
                $(this).closest(".gfield").removeClass("focused");
            }
        });
    }
    if ($(".ow_form").length) {
        $(document).on('focus', 'input', function () {
            $(this).closest("p").addClass("focused");
        });

        $(document).on('blur', 'input', function () {
            if ($(this).val() == '') {
                $(this).closest("p").removeClass("focused");
            }
        });
    }

    /*  Filtri dropdown  */
    $('.cpt-filter__button').on('click', function () {
        var parent = $(this).parent(".cpt-filter");
        if (!parent.hasClass("cpt-filter--active")) {
            $(".cpt-filter").removeClass("cpt-filter--active");
            $(".cpt-filter").find(".cpt-filter__dropdown").slideUp('fast');
        }
        parent.toggleClass("cpt-filter--active");
        parent.find(".cpt-filter__dropdown").slideToggle('fast');
    });

    $('.cpt-filter__dropdown-item input').change(function () {
        var parent = $(this).closest(".cpt-filter");
        parent.removeClass("cpt-filter--active");
        parent.find(".cpt-filter__dropdown").slideUp('fast');

        var slugs = get_filters();
        ajax_okna(slugs);
    });

    $('.cpt-list__clear-filters').click(function () {
        $(".cpt-filter").removeClass("cpt-filter--active");
        $(".cpt-filter").find(".cpt-filter__dropdown").slideUp('fast');
        $(".cpt-filter__dropdown-item input").removeAttr('checked');

        ajax_okna({});
    });

    $(".cpt-list__content").on('click', '.load-more-wrap', function () {
        var slugs = get_filters();
        var offset = parseInt($("#okna-ajax").attr("data-displayed"));
        ajax_okna(slugs, offset);
    });

    $('#wrapper').on("click", ".okno_read_more_buttton_more", function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().find('.okno-card__text--more').slideToggle('fast');
        $(this).parent().find('.okno_read_more_buttton_less').show();
    });
    $('#wrapper').on("click", ".okno_read_more_buttton_less", function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().find('.okno-card__text--more').slideToggle('fast');
        $(this).parent().find('.okno_read_more_buttton_more').show();
    });

    $('.mobile-menu-drower__bottom-search').click(function () {
        $(".mobile-menu-drower-search").fadeIn();
    });

    $('.socket__search').click(function () {
        $('.mobile-hamburger-toggle').trigger("click")
        $(".mobile-menu-drower-search").fadeIn();
    });

    $('.ow_sticky_side_wrap_open_mobile').click(function () {
        $(this).parent().toggleClass("open_meni");
    });
});

$(window).scroll(function () {
    didScroll = true;
});

$(document).on('gform_post_render', function () {
    $('.gform_wrapper .ginput_container:not(.ginput_complex):not(.ginput_container_radio):not(.ginput_container_checkbox) input').each(
        function () {
            if ($(this).val() != '') {
                $(this).closest(".gfield").addClass("focused");
            }
        }
    );

    $('.gform_wrapper .ginput_container select').each(
        function () {
            if ($(this).val() !== '') {
                $(this).closest(".gfield").addClass("focused");
            }
        }
    );
});

$(document).on('gform_confirmation_loaded', function (event, formId) {
    dataLayer.push({'event': 'formSubmittedOW', 'formID': formId});
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
        return;
    }

    // Remove class on top
    if (st < 5) {
        $('header').removeClass('nav-down');
        $('header').removeClass('nav-up');
        return;
    }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}

/*  pridobivanje izbranih filtrov iz dropdown menijev*/
function get_filters() {
    var slugs = {};
    $(".cpt-filter__hidden").each(function () {
        var taxonomy = $(this).data("tax");
        var temp = [];
        temp.push(parseInt($(this).attr("value")));
        if (temp.length > 0) {
            slugs[taxonomy] = temp;
        }
    });
    $(".cpt-filter__dropdown").each(function () {
        var taxonomy = $(this).data("tax");
        var temp = [];
        $(this).find("input[type='checkbox']:checked").each(function () {
            temp.push(parseInt($(this).attr("value")));
        })
        if (temp.length > 0) {
            slugs[taxonomy] = temp;
        }
    });
    return slugs;
}

function ajax_okna(slugs, offset = 0) {
    $.ajax({
        type: "post",
        url: vars.ajaxurl,
        data: {
            action: $(".cpt-list__content").data("function"),
            slugs: JSON.stringify(slugs),
            numOfDisplayed: offset,
            nonceOW: vars.nonce
        },
        beforeSend: function () {
            $(".cpt-list__content").addClass("loading");
            if ((parseInt($("#okna-ajax").attr("data-displayed")) + 3) >= $("#okna-ajax").attr("data-all-posts")) {
                $(".load-more-wrap").hide();
            }
        },
        success: function (data) {
            if (offset != 0) {
                $(".cpt-list__content .okna-seznam").append(data);
                $("#okna-ajax").attr("data-displayed", offset + 3);
            } else {
                $(".cpt-list__content").empty().append(data);
            }
            $('.cpt-list__content').removeClass("loading")

        },
        error: function () {
            $(".cpt-list__content").removeClass("loading");
            alert("error");
        }
    });
}